// $(document).on('change', '.cart-note__input', function () {
//   $.ajax({
//     type: 'POST',
//     url: '/cart/update.js',
//     data: {
//       note: $(this).val()
//     },
//     dataType: 'json'
//   });
// });



$(".product__cart-btn a").on("click",function(e){
  e.preventDefault();
  formData = $(this).closest(".product__add-form").serialize();
  addToCart(formData)
});

$(".button_product_atc").on("click",function(e){
  e.preventDefault();
  formData = $(this).next().serialize();
  addToCart(formData)
})


function addToCart(formData) {
console.log(formData);
$.ajax({
type: "POST",
url: "/cart/add.js",
dataType: "json",
data: formData,
success: function (data) {
  sectionRendering();
  $("body").addClass("active-cart");

},
error: function (err) {
  console.log(err);
},
});
}



function sectionRendering() {
fetch("?section_id=cart-drawer")
.then((res) => res.text())
.then((data) => {
  var cart__html = $(data);
  var render__html = $(".cart__wrap", cart__html);
  $(".cart__wrap").replaceWith(render__html);
  var render__html = $(".cart__count em", cart__html);
  $(".cart__count em").replaceWith(render__html);

});

// header section 
fetch("?section_id=header")
.then((res) => res.text())
.then((data) => {
  var cart__html = $(data);
  var render__html = $(".header__cart p", cart__html);
  $(".header__cart p").replaceWith(render__html);
});
}


// match variant and update variant id and variant image 

function selectedVarint() {
var slectedId = $(".select__variant").val();
var url = new URL(window.location.href);
url.searchParams.set("variant", slectedId);
window.history.replaceState({}, "", url);
}


// match variant 
function matchVariant() {
var updateValue = "";
$(".product__size input[type='radio']:checked").each(function () {
  updateValue += (updateValue ? " / " : "") + $(this).val();
})


$(".select__variant option").each(function () {

var optionValue = $(this).text().trim();

if (updateValue.toLowerCase() == optionValue.toLowerCase()) {

  $(this).prop("selected", true);
  var variant_pirce = $(this).attr("data-variant-price");
  var variant__available = $(this).attr("data-variant-available");
  console.log('variant__available',variant__available);
  $(".product__headding h2 em").text(variant_pirce);
  if(variant__available == 'false'){
      $(".product__cart").addClass("product__not-available")
      $(".product__cart-btn a").text("BACK SOON");
  }else{
      $(".product__cart").removeClass("product__not-available"); 
      $(".product__cart-btn a").text("ADD TO CART");
  }
  
  var variant__image = $(this).attr("data-img");
  var variant__index = $(this).attr("data-index");
  if(variant__index != undefined){
    $('.product__items').slick('slickGoTo', variant__index, false);
  }
  
  // Dispatch variantChanged event for subscription widget integration
  if (typeof document !== 'undefined' && typeof CustomEvent !== 'undefined') {
    document.dispatchEvent(new CustomEvent('variantChanged', {
      detail: {
        variantId: $(this).val(),
        variantPrice: variant_pirce,
        variantAvailable: variant__available
      }
    }));
  }
  
  return true;
}
});

}

$(".product__size input[type='radio']").on('change',function () {
  matchVariant();
  selectedVarint();
})
matchVariant();

// Listen for direct variant select changes (if select is changed programmatically)
$(".select__variant").on('change', function() {
  var selectedOption = $(this).find('option:selected');
  var variant_price = selectedOption.attr("data-variant-price");
  var variant__available = selectedOption.attr("data-variant-available");
  
  // Update price (subscription widget will override if subscription is selected)
  $(".product__headding h2 em").text(variant_price);
  
  // Update availability
  if(variant__available == 'false'){
    $(".product__cart").addClass("product__not-available");
    $(".product__cart-btn a").text("BACK SOON");
  } else {
    $(".product__cart").removeClass("product__not-available"); 
    $(".product__cart-btn a").text("ADD TO CART");
  }
  
  // Dispatch variantChanged event for subscription widget
  if (typeof document !== 'undefined' && typeof CustomEvent !== 'undefined') {
    document.dispatchEvent(new CustomEvent('variantChanged', {
      detail: {
        variantId: $(this).val(),
        variantPrice: variant_price,
        variantAvailable: variant__available
      }
    }));
  }
});




// increment quantity in product page and quick view 
function increment(el) {
var input = el.previousElementSibling;
var value = parseInt(input.value);
console.log(value)
value = isNaN(value) ? 0 : value
value++;
input.value = value;

}
// decrement quantity in product page and quick view 
function decrement(el) {
var input = el.nextElementSibling;
var value = parseInt(input.value);
if (value > 1) {
value = isNaN(value) ? 1 : value;
value--;
input.value = value;

}
}


// increment quantity in cart drawer
function incrementCart(el) {
var input = el.previousElementSibling;
var value = parseInt(input.value);
console.log(value)
value = isNaN(value) ? 0 : value
value++;
input.value = value;
changeQuantity(input);

}
// decrement quantity in cart drawer
function decrementCart(el) {
var input = el.nextElementSibling;
var value = parseInt(input.value);
if (value > 0) {
value = isNaN(value) ? 0 : value;
value--;
input.value = value;
changeQuantity(input);
}
}

function changeQuantity(input) {

var quantity = $(input).val();
var data_line = $(input).attr("data-line");
var data = {
"line": data_line,
"quantity": quantity
};
$.ajax({
type: "POST",
url: "/cart/change.js",
dataType: "json",
data: data,
success: function (data) {
  console.log(data);
  sectionRendering();
},
error: function (err) {
  console.log("Error from quantity update")
}
})


}



// function addToCart(formData) {
//   console.log(formData);
//   $.ajax({
//     type: "POST",
//     url: "/cart/add.js",
//     dataType: "json",
//     data: formData,
//     success: function (data) {
//       console.log(data)
//       sectionRedering();
//       $(".cart").addClass("active");
//       $(".overlay").addClass("active");
//     },
//     error: function (err) {
//       console.log(err);
//     },
//   });
// }




// infinity scroll product in collection page start js here 

// remove item from cart drawer  js start here

/* <img onclick="removeItem(event,this)" data-line="{{ forloop.index }}" src="{{'delete.svg' |  asset_url }}" alt=""> */
function removeItem(event, el) {
event.preventDefault();
var data_line = $(el).attr("data-line");
console.log(data_line)
var deleteData = {
"line": data_line,
"quantity": 0
};

$.ajax({
type: "POST",
url: "/cart/change.js",
dataType: "json",
data: deleteData,
success: function (data) {

sectionRendering();
}
})
}


// remove item from cart drawer js end here










